export const config = {
    envioSms: false,
    production: true,
    
    // apiImage: 'assets/images/pages/login/default.jpg', //Img por defecto
    apiImage: 'assets/images/pages/login/fondo_junta.png', //Consultas web JUNTA

    // apiUrl: 'http://localhost:9000/wsConsulta-2.0' //test localhost

    //    apiUrl: 'http://micooperativabancavirtual.com:9000/wsConsulta-2.0.1' //Prod MiCooperativaDominio
    //    apiUrl: 'https://micooperativabancavirtual.com:8443/wsConsulta-2.0.1' //Prod MiCoop ServerApp
    
    //    apiUrl: 'http://179.60.244.107:9000/wsConsulta-2.0.1' //Prod Caja Betania

    //    apiUrl: 'http://192.168.1.91:9000/wsConsulta-2.0' //Prod Caja Betania
    //    apiUrl: 'http://179.60.244.107:9000/wsConsulta-2.0.1' //Prod Caja Betania

    //    apiUrl: 'http://45.225.107.238:9000/wsConsulta-2.0.1' //Prod Caja Guapan

    //    apiUrl: 'http://190.123.34.157:9000/wsConsulta-2.0.1' //Prod Caja Femir

    apiUrl: 'http://186.68.44.107:9000/wsConsulta-2.0.1' //Caja Junta

    // apiUrl: 'http://192.168.1.43:9000/wsConsulta-2.0.1' //Coop Edu Napo
    
    // apiUrl: 'http://192.168.0.102:9000/wsConsulta-2.0.1' //Coop Atlantida

    // apiUrl: 'http://localhost:9000/wsConsulta-2.0.1' //Caja fenix

};
